<template>
    <div class="disclaimer-container">
        <article
            class="disclaimer"
            :class="[showBackground, showBorder]"
        >
            <div class="disclaimer__inner">
                <zoe-atom-text
                    class="disclaimer__text"
                    :item="content.text.value"
                />
            </div>
        </article>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { componentProps } from '../../../../../mixins/component/component';
import ZoeAtomText from '../../../../atoms/text/v1.0.0/zoe-atom-text.vue';

const props = defineProps({
    content: componentProps.content,
});

const showBackground = computed(() => {
    return props.content.style.background.turnOff.value ? '' : 'disclaimer--background';
});

const showBorder = computed(() => {
    return props.content.style.border.turnOff.value ? '' : 'disclaimer--border';
});
</script>

<style lang="scss" scoped>
@use 'zoe-organism-disclaimer';

@layer organism {
    .disclaimer {
        --background-color: v-bind('content.style.background.color.value');
        --border-color: v-bind('content.style.border.color.value');
    }
}
</style>
